import React from 'react'

interface IcAddCalendarProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcAddCalendar: React.FC<IcAddCalendarProps> = ({
  width = '16px',
  height = '16px',
  color = '#007AFF',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        d="M5.5111 2.89999V5.38889M10.4889 2.89999V5.38889M5.5111 7.87777H10.4889M7.99999 14.1C7.29967 14.1 6.26264 14.1 4.88889 14.1C3.51999 14.1 2.39999 12.98 2.39999 11.6111V6.63333C2.39999 5.26444 3.51999 4.14444 4.88889 4.14444H11.1111C12.48 4.14444 13.6 5.26444 13.6 6.63333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.29999V11.7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.7V12.3438V14.1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.7H14.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.7H9.59999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcAddCalendar
